import { useContext } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFacetData } from '~/context/srp/FacetDataContext';
import { colorHexValues } from './constants';
import Checkbox from '../Checkbox';
import Label from '../Label';
import { CommonWrapper } from '../styles';

type OwnProps = {
  filterKey: 'colors' | 'interiorColors';
};

type LabelProps = {
  displayName: string;
};

const ColorLabel = ({ displayName }: LabelProps) => {
  return (
    <div className="flex items-center justify-between py-2">
      <Label displayName={displayName} />
      {displayName === 'Other' ? (
        <img
          className="h-[24px]"
          src={`${process.env.CVNA_APP_ASSETS_CDN}/serenity-ui/images/other.png`}
          alt="other"
        />
      ) : (
        <div
          className="border border-1 border-solid h-[24px] rounded-full w-[24px]"
          style={{
            background: colorHexValues[displayName],
            borderColor:
              displayName === 'White'
                ? 'var(--cvna-color-grey-2)'
                : colorHexValues[displayName]
          }}
        />
      )}
    </div>
  );
};

const ColorSwatches = ({ filterKey }: OwnProps) => {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const facetData = useFacetData();

  return (
    <CommonWrapper>
      {facetData[filterKey]?.buckets?.map(({ key, displayName }) => (
        <Checkbox
          checked={appliedFilters[filterKey]?.includes(key)}
          className="w-full"
          facet={filterKey}
          filter={key}
          id={`${filterKey} - ${displayName}`}
          key={`${filterKey} - ${displayName}`}
          label={
            <ColorLabel
              displayName={displayName
                .replace(/(interior|exterior)/i, '')
                .trim()}
            />
          }
          onChange={() => {
            updateListFilter({
              value: key,
              filterKey
            });
          }}
        />
      ))}
    </CommonWrapper>
  );
};

export default ColorSwatches;
